import React, { memo, useContext } from "react";
import { GolContactErrorField } from "./gol-contact-error-field";
import { GolContactTextField } from "./gol-contact-text-field";
import {
  GolContactFormContext,
  GolFieldElement,
} from "./gol-contact-form-interfaces";
import { useTranslation } from "react-i18next";

const GolContactNameField = memo((props: GolFieldElement) => {
  const { t } = useTranslation();
  const { name } = props;
  const formContext = useContext(GolContactFormContext);
  const { form, fieldsInErrors, handleFormChange, requiredFields } =
    formContext;
  const value = form[name];
  const required = props.required ? true : requiredFields.includes(name);
  const fieldInError = fieldsInErrors.includes(name);
  const fieldFills = typeof value !== "undefined" && value != null;
  const errorMsg = fieldInError
    ? required && !fieldFills
      ? t("instabook.contacts.required_field_error")
      : t("instabook.errors.invalid_field")
    : "";
  const defaultClazzName = props.clazz ?? name;
  const clazz = fieldInError
    ? `${defaultClazzName} error`
    : `${defaultClazzName} `;

  const defaultFieldValues = {
    ...props,
    value,
    label: t(`instabook.contacts.${name}`),
    clazz,
    required,
    errorMsg,
    onChange: handleFormChange,
  } as GolFieldElement;
  return (
    <>
      {required ? (
        <GolContactErrorField {...defaultFieldValues} />
      ) : (
        <GolContactTextField {...defaultFieldValues} />
      )}
    </>
  );
});

export { GolContactNameField };
